import removeSuppressReceiptFromItem from '../actions/removeSuppressReceiptFromItem';
import { mutator } from 'satcheljs';

const SUPPRESS_READ_RECEIPT_ACTION_TYPE = 'SuppressReadReceipt:#Exchange';

/**
 * Mutates the response objects by removing the suppress read receipt action
 */
export const removeSuppressReceiptFromItemMutator = mutator(
    removeSuppressReceiptFromItem,
    actionMessage => {
        const { message } = actionMessage;
        message.ResponseObjects = message.ResponseObjects.filter(
            obj => obj.__type != SUPPRESS_READ_RECEIPT_ACTION_TYPE
        );
    }
);
